module.exports = __webpack_public_path__ + "img/nato.27f74166.png";